<template>
  <div class="content">
    <el-date-picker
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      v-model="searchTime"
      @change="search"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
    ></el-date-picker>
    <el-button type="primary" class="anniu" icon="el-icon-search" @click="search" style="margin-left:15px">搜索</el-button>
    <el-button type="primary" icon="el-icon-refresh" @click="handleCls">重置</el-button>
    <el-button type="primary" icon="el-icon-download" @click="handleExport">导出</el-button>
    <div class="table" style="margin-top: 10px">
      <p class="p_class">
        <span>业务号：<i>{{datas.missionId}}</i></span>
        <span>实际划拨数：<i>{{datas.transferCard}}</i></span>
        <span>首冲卡片数：<i>{{datas.firstCharge}}</i></span>
        <span>首冲率：<i>{{datas.firstRate}}</i></span>
        <span>复充卡片数：<i>{{datas.againCharge + '%'}}</i></span>
        <span>复冲率：<i>{{datas.againRate+ '%'}}</i></span>
      </p>
      <el-table :data="tableData" border style="width: 95%;margin-top: 10px;">
        <el-table-column prop="statisticalDate" label="时间" align="center"></el-table-column>
        <el-table-column prop="firstCharge" label="首冲卡片" align="center"></el-table-column>
        <el-table-column prop="againCharge" label="复充卡片" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { rechargeInfo } from "@/api/api.js"; //详情
import { rechargeRecord } from "@/api/api.js"; //详情列表
import { rechargeExport } from "@/api/api.js"; //导出
export default {
  data() {
    return {
      searchTime:'',
      tableData:[],
      page: 1,
      pageSize: 20,
      total: 0,
      id:this.$route.query.id,
      datas:{}
    };
  },
  methods: {
    // 获取初始化数据
    initData() {
      let params = {
        id:this.id
      };
      rechargeInfo(params).then(res => {
        if (res.data.code == 200) {
          this.datas = res.data.data
          let datas = {
            model:{
              missionId:res.data.data.missionId
            }
          };
          // 搜索日期
          if (this.searchTime && this.searchTime[0]) {
            datas.model.startTime = this.searchTime[0];
            datas.model.endTime = this.searchTime[1];
          }
          rechargeRecord(datas).then(res => {
            if (res.data.code == 200) {
              this.tableData = res.data.data.records;
              this.total = res.data.data.total;
            }
          })
        }
      })
    },
    // 搜索
    search(){
      this.initData();
    },
    // 重置
    handleCls(){
      this.page = 1;
      this.pageSize = 20;
      this.searchTime = [];
      this.initData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    // 导出
    handleExport(){
      let params ={
        missionId:this.datas.missionId
      }
      rechargeExport(params).then(res =>{
        if(res.data.code == 200){
          this.$notify({
            title: "提示",
            message: "已提交导出，请在任务中心查看进度",
            type: "success"
          });
          setTimeout(()=>{
            this.$router.push({ path: `/taskCenter/missionList`});
          },1000)
        }else{
          this.$message.error(res.data.message);
        }
      })
    }
  },
  created() {

  },
  mounted() {
    this.initData();
  },
};
</script>
<style scoped lang="less">
.p_class{
  width: 95%;
  display: flex;
  justify-content:space-between;
}
.p_class span i{
  color: #ffba4d;
  font-weight: bold;
}
</style>


